import { render } from "./ResultBoard.vue?vue&type=template&id=73a283e2"
import script from "./ResultBoard.vue?vue&type=script&lang=js"
export * from "./ResultBoard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__